import type { AuthInstanceInterface } from '../context/Auth/AuthContext';

export enum AuthStatus {
  LOGGED_OUT,
  LOGGED_IN_CONNECTING_TO_GAME_SERVER,
  LOGGED_IN_CONNECTED_TO_GAME_SERVER,
  LOGGING_OUT,
}

export interface AuthState {
  auth: AuthInstanceInterface | null;
  authIdToken: string | null;
  status: AuthStatus;
  anonymous: boolean;
  error: Error | null;
}

export const authDefault: AuthState = {
  auth: null,
  authIdToken: null,
  status: AuthStatus.LOGGED_OUT,
  anonymous: false,
  error: null,
};
